<template>
    <v-dialog v-model="visible" :max-width="900" overlay-opacity="0.78" content-class="slider__dialogo" @click:outside="cerrar">
        <v-card v-if="slides.length" class="slider" color="#0e1326" dark>
            <v-btn icon small class="slider__cerrar" title="Cerrar" @click="cerrar"><v-icon>close</v-icon></v-btn>

            <v-carousel
                v-model="actual"
                :cycle="slides.length > 1"
                :interval="7000"
                :show-arrows="slides.length > 1"
                :hide-delimiters="slides.length < 2"
                hide-delimiter-background
                delimiter-icon="fiber_manual_record"
                height="auto"
            >
                <v-carousel-item v-for="slide in slides" :key="slide.slide_id">
                    <component
                        :is="slide.enlace ? 'a' : 'div'"
                        :href="slide.enlace || undefined"
                        :target="slide.enlace ? '_blank' : undefined"
                        :rel="slide.enlace ? 'noopener' : undefined"
                        class="slider__imagen"
                        :class="{'slider__imagen--enlace': !!slide.enlace}"
                        :title="slide.enlace ? 'Abrir enlace' : slide.titulo"
                    >
                        <img :src="slide.imagen_url" :alt="slide.titulo" draggable="false">
                    </component>
                </v-carousel-item>
            </v-carousel>

            <div class="slider__pie">
                <span class="slider__titulo">{{ slides[actual] ? slides[actual].titulo : '' }}</span>
                <v-spacer></v-spacer>
                <a v-if="slides[actual] && slides[actual].enlace" :href="slides[actual].enlace" target="_blank" rel="noopener" class="slider__enlace">
                    Más información <v-icon x-small color="secondary">open_in_new</v-icon>
                </a>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
/**
 * Ventana emergente con el carrusel de imágenes vigentes del slider
 * (Administración → Videos y slider → Slider). Se monta en el ingreso
 * (contexto "login") y en el inicio del participante (contexto "inicio").
 * La frecuencia de cada imagen (cada visita, una vez al día, una sola vez) se
 * controla en el navegador con una clave de localStorage por slide. Si no hay
 * imágenes que mostrar, no renderiza nada.
 */
const CLAVE = (id) => `slide_visto_${id}`;

export default {
    name: "SliderPopup",
    props: {
        contexto: {type: String, default: "inicio"},
    },
    data() {
        return {
            slides: [],
            actual: 0,
            visible: false,
        };
    },
    methods: {
        hoy() {
            return new Date().toISOString().slice(0, 10);
        },
        leer(id) {
            try {
                return localStorage.getItem(CLAVE(id));
            } catch (e) {
                return null;
            }
        },
        marcar(id) {
            try {
                localStorage.setItem(CLAVE(id), this.hoy());
            } catch (e) { /* almacenamiento no disponible */ }
        },
        /** La imagen se muestra según su frecuencia y lo que ya se vio en este navegador. */
        toca(slide) {
            const visto = this.leer(slide.slide_id);
            if (slide.frecuencia === "una_vez") return !visto;
            if (slide.frecuencia === "una_vez_por_dia") return visto !== this.hoy();
            return true;
        },
        cargar() {
            window.axios.get("/slides", {params: {contexto: this.contexto}}).then(response => {
                if (!response.data.success) return;

                const vigentes = (response.data.data || []).filter(s => this.toca(s));
                if (!vigentes.length) return;

                this.slides = vigentes;
                this.actual = 0;
                vigentes.forEach(s => this.marcar(s.slide_id));
                this.visible = true;
            }).catch(() => { /* sin slider */ });
        },
        cerrar() {
            this.visible = false;
        },
    },
    watch: {
        // Avisa a los demás emergentes (video promocional) para que no se encimen.
        visible(valor) {
            window.dispatchEvent(new CustomEvent("slider-popup", {detail: valor ? "abierto" : "cerrado"}));
        },
    },
    created() {
        this.cargar();
    },
}
</script>

<style lang="scss" scoped>
.slider {
    position: relative;
    overflow: hidden;
}

.slider__cerrar {
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 3;
    background: rgba(0, 0, 0, .45);
}

.slider__imagen {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-height: 72vh;
    background: #000;

    img {
        display: block;
        max-width: 100%;
        max-height: 72vh;
        object-fit: contain;
    }

    &--enlace {
        cursor: pointer;
    }
}

.slider__pie {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;
    font-size: .85rem;
}

.slider__titulo {
    font-weight: 600;
}

.slider__enlace {
    color: #e6bd7a;
    font-size: .8rem;
    text-decoration: none;
    white-space: nowrap;
}
</style>
